import {createAuthModule, JWTPayload, UpdatedUserAttributes} from "@memaro/auth"
import {parseBool} from "./util.ts";

type UserAttributes = {
    acceptedTerms: boolean
}

const module = createAuthModule({
    cognito: {
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolEndpoint: import.meta.env.VITE_COGNITO_USER_POOL_ENDPOINT,
        oauthDomain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
    },
    userAttributeMapper: (attributes: JWTPayload): UserAttributes =>  ({
        acceptedTerms: parseBool(attributes["custom:accepted_terms"] as string | undefined ?? "false")
    }),
    reverseUserAttributeMapper: (attributes: Partial<UserAttributes>): UpdatedUserAttributes => {
        const updatedAttributes: UpdatedUserAttributes = {}
        if (attributes.acceptedTerms !== undefined) {
            updatedAttributes["custom:accepted_terms"] = String(attributes.acceptedTerms)
        }
        return updatedAttributes
    }
})

export const useAuth = module.useAuth

export const AuthProvider = module.Provider

export const tokenRetriever = module.tokenRetriever
